import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import styles from "./index.module.scss";
import AppCtrl from "../../../control/AppCtrl";
import Utils from "../../../utils/Utils";
import LANGUAGE_TYPE from "../../../utils/Language";
import Config from "../../../utils/Config";
import EFunction from "../../../utils/FunctionPage";
import switchFunc from "../../../redux/switchFunc/switchFuncAction";
import useAlert from "../../../hook/useAlert";
import Input from "../../_component/Input";
import Button from "../../_component/Button";

function RegisterPage() {
  const text = Config.text.registerPage;
  const { setFunc } = switchFunc();
  const { showAlert } = useAlert();
  const navigate = useNavigate();

  const [registerAccount, setRegisterAccount] = useState("");
  const [registerPhoneNo, setRegisterPhoneNo] = useState("");

  //===========================================================================
  useEffect(() => {
    componentDidMount();
    return componentWillUnmount;
  }, []);
  //===========================================================================

  function PreLoad() {
    // const language = AppCtrl.getLanguage();
    // const uigmAccountInput = document.getElementById("gmAccountInput");
    // uigmAccountInput.value = AppCtrl.getRegisterGM();
    // const uiprefixInput = document.getElementById("prefixInput");
    // uiprefixInput.value = AppCtrl.getPrefix();
    // const uicountryCode = document.getElementById("countryCode");
    // if (uicountryCode) uicountryCode.value = Config.countryCode;
    //const uiRegisterNotice = AppCtrl.getRegisterNotice();
    // if (language == LANGUAGE_TYPE.en_US) {
    //     const uiregister = document.getElementById('register');
    //     if (uiregister) uiregister.innerHTML = "Register";
    //     const uibtnUserChangePasswordOk = document.getElementById('btnUserChangePasswordOk');
    //     if (uibtnUserChangePasswordOk) uibtnUserChangePasswordOk.innerHTML = "OK";
    //     const uiBtnSettingsPageBack = document.getElementById('btnSettingsPageBack');
    //     if (uiBtnSettingsPageBack) uiBtnSettingsPageBack.innerHTML = "Cancel";
    //     const uiuserTelephone = document.getElementById('userTelephone');
    //     if (uiuserTelephone) uiuserTelephone.innerHTML = "Telephone";
    //     const uiuserAccountInput = document.getElementById('userAccountInput');
    //     if (uiuserAccountInput) uiuserAccountInput.placeholder = "New Account";
    //     const uiuserTelephoneInput = document.getElementById('userTelephoneInput');
    //     if (uiuserTelephoneInput) uiuserTelephoneInput.placeholder = "User Telephone";
    //     const uiuserRegisterAccount = document.getElementById('userRegisterAccount');
    //     if (uiuserRegisterAccount) uiuserRegisterAccount.innerHTML = "Account: Character and Number Only!";
    //     const uiuserRegisterAccountInput = document.getElementById('userRegisterAccountInput');
    //     if (uiuserRegisterAccountInput) uiuserRegisterAccountInput.placeholder = "User Account";
    //     const uibtnUserRegisterOk = document.getElementById('btnUserRegisterOk');
    //     if (uibtnUserRegisterOk) uibtnUserRegisterOk.innerHTML = "OK";
    //     const uibtnUserRegisterPageBack = document.getElementById('btnUserRegisterPageBack');
    //     if (uibtnUserRegisterPageBack) uibtnUserRegisterPageBack.innerHTML = "Back";
    // }
  }

  function componentDidMount() {}

  function componentDidUpdate() {}

  function componentWillUnmount() {}

  function onUserRegisterOk() {
    const language = AppCtrl.getLanguage();
    try {
      if (registerAccount.length <= 0) {
        if (language === LANGUAGE_TYPE.zh_TW) throw new Error("請輸入帳號");
        else throw new Error("Please Input Account");
      } else if (!registerAccount.match("^[A-Za-z0-9]+$")) {
        if (language === LANGUAGE_TYPE.zh_TW)
          throw new Error("只能輸入英文字母以及數字!");
        else throw new Error("Number and A-Z or a-z only!");
      }

      var phoneNumber = parseInt(registerPhoneNo);
      if (phoneNumber < Config.minPhoneNO || phoneNumber > Config.maxPhoneNo) {
        if (language == LANGUAGE_TYPE.zh_TW) throw new Error("請輸入電話號碼!");
        else throw new Error("Please Input Telephone!");
      }

      var sphoneNumber = registerPhoneNo.toString();
      if (sphoneNumber) {
        var bCheckNo = false;
        const char1 = sphoneNumber.charAt(0);
        for (var i = 0; i < Config.firstPhoneNO.length; i++) {
          if (char1 === Config.firstPhoneNO[i].toString()) {
            bCheckNo = true;
            break;
          }
        }

        if (bCheckNo === false) {
          if (language == LANGUAGE_TYPE.zh_TW)
            throw new Error("請輸入正確的電話號碼!");
          else throw new Error("Incorrect Telephone!");
        }
      }

      var PrefixAccount = AppCtrl.getPrefix() + registerAccount;
      //const url = new URL(window.location.href);
      const GM = AppCtrl.getRegisterGM();
      const PhoneNo = registerPhoneNo;
      //const GiftEnabled = true;
      const GiftEnabled = "true";

      const url = "APIs/CreateAccount.ashx";
      const data = {
        gm: GM,
        userid: PrefixAccount,
        nickName: PrefixAccount,
        phoneNo: PhoneNo,
        giftEnabled: GiftEnabled,
      };
      Utils.postAPI(url, data, "x-www-form-urlencoded")
        .then(function (response) {
          //resolve(response);
          //var result = response.ResultObject;
          var result = response.ResultCode;
          if (result === "OK") {
            AppCtrl.setCookie("name", PrefixAccount);
            AppCtrl.setCookie("password", PhoneNo);
            AppCtrl.setCookie("remeberMe", true);

            var confirmButtonText;
            if (language === LANGUAGE_TYPE.zh_TW) {
              result = `恭喜註冊帳號成功!!!\r\n
                                    您的帳號: ${PrefixAccount}\r\n
                                    請先使用您的電話號碼:\r\n
                                    ${PhoneNo}\r\n
                                    登入後再修改您的密碼!!!`;
              confirmButtonText = "確定";
            } else {
              result = `Successful!!!\r\n
                                    Your Account: ${PrefixAccount}\r\n
                                    Please Login With your PhoneNo:\r\n
                                    ${PhoneNo} then change your PW\r\n
                                    Firstly.`;
              confirmButtonText = "OK";
            }
            showAlert({
              title: result,
              icon: "success",
              confirmButtonText,
              confirmCb: () => {
                window.location.reload();
              },
            });
          } else {
            result = response.ResultCode;
            switch (result) {
              case "E0001": {
                if (language === LANGUAGE_TYPE.zh_TW) result = "無效的GM";
                else result = "invalid GM";
                break;
              }
              case "E0002":
              case "E0003": {
                if (language === LANGUAGE_TYPE.zh_TW) result = "無效的帳號";
                else result = "invalid username or account";
                break;
              }
              case "E0004": {
                if (language === LANGUAGE_TYPE.zh_TW)
                  result = "電話號碼格式有問題";
                else result = "invalid phoneNo";
                break;
              }
              case "E0005": {
                if (language === LANGUAGE_TYPE.zh_TW)
                  result = "此帳號已經有人使用";
                else result = "invalid username";
                break;
              }
              case "E0006": {
                if (language === LANGUAGE_TYPE.zh_TW)
                  result = "此帳號已經有人使用-6";
                else result = "invalid username-6";
                break;
              }
              case "E0007": {
                if (language === LANGUAGE_TYPE.zh_TW)
                  result = "無效的代理人-7";
                else result = "invalid gm-7";
                break;
              }
              default: {
                if (language === LANGUAGE_TYPE.zh_TW) result = "未知的錯誤";
                else result = "unknow issue";
                break;
              }
            }
            throw new Error(result);
          }
        })
        .catch(function (error) {
          console.log(error);
          // AppCtrl.alert(error.toString());
          showAlert({ title: error.toString() });
        });
    } catch (error) {
      console.log(error);
      // AppCtrl.alert(error.toString());
      showAlert({ title: error.toString() });
    }
  }

  function onBack() {
    //setFunc(EFunction.winLobby);
    setFunc(EFunction.loginPage);
    // navigate('/lobby');
  }

  const accountHandler = useCallback((e) => {
    setRegisterAccount(e.target.value);
  }, []);

  const phoneNoHandler = useCallback((e) => {
    setRegisterPhoneNo(e.target.value);
  }, []);

  return (
    <div className={styles.registerPage}>
      <div className={styles.mainArea}>
        <h3>{`${text.register}`}</h3>
        <div style={{ maxWidth: "320px" }}>
          <div className={styles.label}>{`${text.gmAccount}`}:</div>
          <Input
            className={styles.gmAccountInput}
            disabled
            value={AppCtrl.getRegisterGM()}
          />
          <div className={styles.label}>{`${text.userRegisterAccount}`}:</div>
          <div className={styles.prefixContainer}>
            <Input
              className={styles.prefixInput}
              disabled
              value={AppCtrl.getPrefix()}
            />
            <Input
              className={styles.registerInput}
              value={registerAccount}
              onChange={accountHandler}
              placeholder={`${text.userRegisterAccountInput_placeholder}`}
            />
          </div>
          <div className={styles.label}>{`${text.userTelephone}`}:</div>
          <div className={styles.prefixContainer}>
            <Input
              className={styles.prefixInput}
              disabled
              value={Config.countryCode}
            />
            <Input
              type="number"
              className={styles.registerInput}
              value={registerPhoneNo}
              onChange={phoneNoHandler}
              placeholder={`${text.userTelephoneInput_placeholder}`}
            />
          </div>
          <div className={styles.btnContainer}>
            <Button
              className={`large blue ${styles.btn}`}
              onClick={onUserRegisterOk}
              text={`${text.btnUserRegisterOk}`}
            />
            <Button
              className={`large red ${styles.btn}`}
              onClick={onBack}
              text={`${text.btnUserRegisterPageBack}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;
